export class NotImplementedError extends Error {
    readonly name: string = "NotImplementedError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
